import { render, staticRenderFns } from "./TeacherIndividualLeaveAssignmentModal.vue?vue&type=template&id=7b82fdb8&scoped=true&"
import script from "./TeacherIndividualLeaveAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualLeaveAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82fdb8",
  null
  
)

export default component.exports